import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[PromptForge] Uncaught error:', error, errorInfo);
  }

  handleReset = () => {
    try {
      localStorage.removeItem('promptforge-storage');
    } catch {
      // ignore
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-6">
          <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 shadow-sm">
            <h1 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
              應用程式發生錯誤
            </h1>
            <p className="text-sm text-slate-600 dark:text-slate-300 mb-4">
              這可能是由舊的本地資料或瀏覽器兼容性問題引起的。請嘗試清除本地資料並重新載入。
            </p>
            {this.state.error && (
              <pre className="text-xs bg-slate-100 dark:bg-slate-900 p-3 rounded-lg text-red-600 dark:text-red-400 mb-4 overflow-auto max-h-40">
                {this.state.error.message}
              </pre>
            )}
            <button
              type="button"
              onClick={this.handleReset}
              className="w-full px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors"
            >
              清除本地資料並重新載入
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
